'use client'
import { useState, useEffect } from 'react'
import Header from 'components/privat/Header'
import Content from 'components/privat/Content'
import { useMainContext, PrivateContext } from 'utils/context'
import { getFedData } from 'services/private'
import LeftMenu from 'components/privat/LeftMenu'
import { Toaster } from 'sonner'

const Layout = ({ children }) => {
  const [fedDetails, setFedDetails] = useState({})
  const [forceUpdateFed, setForceUpdateFed] = useState(0)
  const [showModalMsg, setShowModalMsg] = useState(false)
  const { setIsLogged, isLogged, fedId, fedToken, setShowModal } =
    useMainContext()

  const getFed = async () => {
    if (fedId) {
      const fedData = await getFedData({ user: fedId, token: fedToken })
      if (fedData?.resultado === 'ERROR') {
        localStorage.removeItem('fedId')
        localStorage.removeItem('fedToken')
        setIsLogged(false)
        setShowModal(true)
      } else {
        const profileImg = fedData.PersonalInformation.image1
        fedData.PersonalInformation.photo = profileImg
          ? profileImg
          : fedData.PersonalInformation.imageNotApproved ||
            '/assets/images/players/no-photo.svg'
        setFedDetails(fedData)
      }
    }
    if (!fedId && fedId !== 0) {
      setShowModal(true)
    }
  }

  useEffect(() => {
    getFed()
  }, [fedId, forceUpdateFed])

  return isLogged ? (
    <PrivateContext.Provider
      value={{ fedDetails, forceUpdateFed, setForceUpdateFed, setShowModalMsg }}
    >
      {fedDetails?.PersonalInformation && <Header fed={fedDetails} />}
      <Content menu={<LeftMenu />}>{children}</Content>
      {showModalMsg && (
        <ModalMsg
          showModalMsg={showModalMsg}
          setShowModalMsg={setShowModalMsg}
          isSmall={true}
          // actionAfterClose={() => {
          //   localStorage.setItem('showModalMsg', false)
          // }}
        />
      )}
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            fontFamily: 'alliance-regular'
          }
        }}
      />
    </PrivateContext.Provider>
  ) : (
    <div className="min-h-[700px]"></div>
  )
}

export default Layout
